import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%'
  },

  backdrop: {
    zIndex: 1,
    position: 'absolute',
    top: '0',
    left: '0',
    transform: 'translate(-50%, -50%)',
    width: '300vw',
    height: '300svh'
  },

  button: {
    position: 'absolute',
    bottom: '5rem',
    right: '1.5rem',
    borderRadius: '50%',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    height: 64,
    width: 64,
    display: 'flex',
    alignItems: 'center',
    border: '0',
    cursor: 'pointer',
    flexDirection: 'column',
    justifyContent: 'center'
  }
}))

export default useStyles
